"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var variables_1 = require("../../../style/variables");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var internalStyles = {
    optionList: react_1.css({
        width: 66,
        minWidth: 66,
        maxWidth: 66,
        height: 256,
        minHeight: 256,
        maxHeight: 256,
        overflow: 'overlay',
        scrollBehavior: 'smooth',
    }),
    optionItem: react_1.css({
        borderRadius: "var(" + variables_1.BorderRadius.sm + ")",
        height: 32,
        width: 58,
        minWidth: 58,
        minHeight: 32,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ':hover': {
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
        },
    }),
    selectedOptionItem: react_1.css({
        backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_4 + ")",
    }),
};
var OptionItem = function (_a) {
    var isSelected = _a.isSelected, children = _a.children, props = __rest(_a, ["isSelected", "children"]);
    var ref = react_2.useRef(null);
    react_2.useEffect(function () {
        if (isSelected) {
            var timerId_1 = setTimeout(function () {
                if (ref.current && ref.current.parentElement) {
                    ref.current.parentElement.scrollTo({
                        top: ref.current.offsetTop - ref.current.parentElement.offsetTop,
                    });
                }
            }, 200);
            return function () {
                clearTimeout(timerId_1);
            };
        }
    }, [isSelected]);
    return (react_1.jsx("div", __assign({ ref: ref, css: [
            internalStyles.optionItem,
            isSelected ? internalStyles.selectedOptionItem : undefined,
        ] }, props),
        react_1.jsx(Text_1.default.Body, { color: "var(" + variables_1.RootColor.Gray.DARK_4 + ")" }, children)));
};
var Options = function (props) {
    var _a = props.options, options = _a === void 0 ? [] : _a, selected = props.selected, onSelect = props.onSelect;
    var optionItems = react_2.useMemo(function () { return options.map(function (option) { return (react_1.jsx(OptionItem, { key: option, onClick: function () { return onSelect(option); }, isSelected: option === selected }, option)); }); }, [options, selected]);
    return (react_1.jsx(layout_1.Flex, { direction: "column", alignItems: "center", css: internalStyles.optionList }, optionItems));
};
exports.default = Options;
